<template>
    <div class="p-relative">

        <Toolbar :isList="true" :hideCreateButton="hideCreate" :menu="menu" v-on:toolbar-button-click="onToolbarClick">

            <div class="top-btns-bar-right-section">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Что ищем? Например: краткое содержание"
                    hide-details
                    class="search-in-tooltip"
                    solo
                    flat
                    clearable
                ></v-text-field>
            </div>

        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="collection"
        />

        <component :is="collection" :search="search" ref="childComponent"/>
        
        <CreateRequisiteDlg ref="CreateRequisiteDlgRef" />
        <CreateRequisitesGroupDlg ref="CreateRequisitesGroupDlgRef" />

        <input type="file" ref="importRef" @change="onImportPicked" style="display: none" accept=".txt,.json" />

    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { httpAPI, errorHandler } from "@/api/httpAPI";
import Toolbar from '@/components/Toolbar.vue';
import FilterPanel from '@/components/FilterPanel.vue';

import Requisites from './lists/Requisites.vue';
import RequisitesGroups from './lists/RequisitesGroup.vue';
import Templates from './lists/Templates.vue';
import Workflows from './lists/Workflows.vue';

import CreateRequisiteDlg from '@/components/templates/dialogs/CreateRequisiteDlg.vue';
import CreateRequisitesGroupDlg from '@/components/templates/dialogs/CreateRequisitesGroupDlg.vue';

export default {
    name: "TemplatesProxy",
    components: {
        Toolbar,
        FilterPanel,
        Requisites,
        RequisitesGroups,
        Templates,
        Workflows,
        CreateRequisiteDlg,
        CreateRequisitesGroupDlg
    },
    data() {
        return {
            filterDataSource: null,
        }
    },
    computed: {
        ...mapGetters('auth', ['getUserInfo']),
        menu() {
            return [
                { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить форму", Type: null },
                { Action: "Export", Icon: "copy", Items: null, Text: "Экспорт", ToolTip: "Экспортировать данные модуля", Type: null },
                { Action: "Import", Icon: "add", Items: null, Text: "Импорт", ToolTip: "Импортировать данные модуля", Type: null }
            ];
        },
        collection: {
            get: function() {
                return this.$store.getters['templates/getCollection']
            },
            set: function(newValue) {
                this.$store.commit('templates/SET_COLLECTION', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['templates/getSearch']
            },
            set: _.debounce(function(v) {
                this.$store.commit('templates/PUSH_SEARCH', { collection: this.collection, value: v } );

                if (typeof this.$refs.childComponent?.resetPage === "function") { 
                    this.$refs.childComponent.resetPage();
                }
            }, 500)
        },
        hideCreate() {
            return false;
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        async onToolbarClick (event, btn) {
            switch(btn.Action)
            {
                case 'Refresh':
                    if (typeof this.$refs.childComponent?.getData === "function")
                        this.$refs.childComponent.getData(true);

                    break;

                case 'Export':
                    await this.Export();
                    break;

                case 'Import':
                    this.Import();
                    break;

                default:
                    break;
            }
            
        },
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `/api/templates/filter`,
                method: 'GET',
            });

            this.filterDataSource = filterResponse?.data.payload;
        },
        async OpenRequisite(r) {
            let result = await this.$refs.CreateRequisiteDlgRef.open({ requisite: JSON.parse(JSON.stringify(r)) });

            if (result.action === 'save') {
                await this.saveObject('Documents.Requisite', result.object, true);

                if (this.collection == 'Requisites')
                    this.$refs.childComponent.getData(true);

                return;
            }
        },
        async OpenRequisitesGroup(rg) {
            let result = await this.$refs.CreateRequisitesGroupDlgRef.open({ requisiteGroup: JSON.parse(JSON.stringify(rg)) });

            if (result.action === 'save') {
                await this.saveObject('Administration.Reference', result.object, false);

                if (this.collection == 'RequisitesGroups')
                    this.$refs.childComponent.getData(true);

                return;
            }
        },
        async saveObject(type, object, common) {
            try
            {
                this.setOverlayVisible({ visible: true, message: 'Сохранение...' });

                let response = await httpAPI({
                    url: `api/save?type=${type}`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'isCommon': common },
                    data: { Content : JSON.stringify({ parent: object, childrens: null }) },
                });

                if (response)
                    this.$notify.success(response.data.payload.Message);
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        },
        async Export() {
            let exportRequest = httpAPI({ 
                url: `api/templates/export`,
                method: 'GET', 
                responseType: 'blob', 
                skipErrorHandler: true, 
                headers: { 'isCommon': true, 'token': localStorage.getItem('Token') }, 
            });

            // при успешном выполнении запроса на формирование отчёта выполнить:
            var onResolve = (response) => {
                this.$notify.success(`Экспорт завершен`);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');

                let header = response.headers['content-disposition'];

                console.log(header);

                let parts = header.split(';');
                let filename = parts[1].split('=')[1];

                link.href = url;
                link.setAttribute('download', filename );
                document.body.appendChild(link);
                link.click();
            };
            // при неудачном выполнении запроса на формирование отчёта выполнить:
            var onReject = (error) => {
                errorHandler(error);
            };
            
            let asyncReportToastMessage = `Экспорт данных`;
            this.$notify.async(exportRequest, onResolve, onReject, asyncReportToastMessage, { icons: { enabled: true } });
        },
        Import() {
            this.$refs.importRef?.click();
        },
        async onImportPicked(e) {
            try
            {
                this.setOverlayVisible({ visible: true, message: 'Сохранение...' });
                let files = Array.from(e.target.files);    

                if (files.length == 0)
                    return;
                
                let formData = new FormData();
                formData.append('file', files[0]);
                
                let importResponse = await httpAPI({ url: `/api/templates/import`, method: 'POST', data: formData, headers: { "Content-Type": "multipart/form-data" } });
                
                if (importResponse)
                    this.$notify.success(importResponse.data.payload.Message);

                if (this.$refs.importRef)
                    this.$refs.importRef.value = null;
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        }
    },
    async created() {
        this.$eventBus.$on('on-templates-module-action', async (eventArgs) => {
            let action = this[eventArgs.action];

            if (typeof action === 'function')
                await action(eventArgs.object);
        });

        this.setOverlayVisible({ visible: true });
        await this.loadFilters();
        this.setOverlayVisible({ visible: false });
    },
    beforeDestroy() {
        this.$eventBus.$off('on-templates-module-action');
    }
}
</script>